import React, { useState, useRef, useEffect } from 'react';
import { useI18n, AVAILABLE_LANGUAGES } from '../context/i18nContext';
import Flag from './Flag';

const LanguageSwitcher = () => {
  const { language, setLanguage, t } = useI18n();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const currentLang = AVAILABLE_LANGUAGES.find((l) => l.code === language);

  // Kattintás a dropdown-on kívülre → bezárás
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (code) => {
    setLanguage(code);
    setIsOpen(false);
  };

  return (
    <div className="language-switcher" ref={dropdownRef}>

      {/* "Select language" felirat az aktuális nyelven */}
      <span className="lang-label">{t('common.selectLanguage')}</span>

      {/* Trigger gomb – a kiválasztott nyelvet mutatja */}
      <button
        className="lang-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        <span className="flag"><Flag code={currentLang?.code} /></span>
        <span className="code">{currentLang?.code.toUpperCase()}</span>
        <span className={`lang-arrow ${isOpen ? 'open' : ''}`}>▾</span>
      </button>

      {/* Drop-down lista */}
      {isOpen && (
        <ul className="lang-dropdown" role="listbox">
          {AVAILABLE_LANGUAGES.map((lang) => (
            <li
              key={lang.code}
              role="option"
              aria-selected={language === lang.code}
              className={`lang-option ${language === lang.code ? 'active' : ''}`}
              onClick={() => handleSelect(lang.code)}
            >
              <span className="flag"><Flag code={lang.code} /></span>
              <span className="lang-name">{lang.name}</span>
              {language === lang.code && <span className="lang-check">✓</span>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;